import { useQuery, useMutation } from '@tanstack/react-query';

import { medusaApiClient, queryClient } from '@/services/apiClient';
import type { AuthUser } from '@/utils/types/auth/user';

export const useAuthenticate = () => {
  return useMutation(
    (data: AuthUser) =>
      // TODO: handle cookies set based on data.rememberMe
      medusaApiClient.auth.authenticate({
        email: data.email,
        password: data.password,
      }),
    {
      onSuccess: (response, vars) => {
        queryClient.setQueryData(['user'], {
          ...(response as any),
          rememberMe: vars.rememberMe,
        });
      },
    },
  );
};

export const useGetUser = () => {
  return useQuery(
    ['user'],
    () =>
      medusaApiClient.customers
        .retrieve({ expand: `billing_address` })
        .then(({ customer }) => customer),
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
};

export const useGetCustomerOrders = () => {
  return useQuery(
    ['orders'],
    () => medusaApiClient.customers.listOrders().then(({ orders }) => orders),
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
};

export const useSignOut = () => {
  return useMutation(() => medusaApiClient.auth.deleteSession(), {
    onSuccess: () => queryClient.setQueryData(['user'], null),
  });
};
